import actionTypes from 'dashboard/actions/net-sales/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NET_SALES_SUMMARY_SUCCESS:
      return { ...action.netSalesSummary };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/net-sales/net-sales-summary.js